"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showPriceDiscount = exports.getOriginalPrices = exports.showLowestPriceLastMonth = exports.getRoundedPrice = exports.prefixPriceWithCurrency = exports.generateCotopaxiPriceViewModel = exports.ProductPriceStates = exports.setColorPrices = exports.mapEdgePriceToPricesObject = void 0;
const common_types_1 = require("@as-react/common-types");
const general_util_1 = require("./general.util");
const PRICE_STATUS_VISUAL = {
    SELL: {
        '1': common_types_1.PRICE_STATE_FROM,
        '3': common_types_1.PRICE_STATE_FROM,
        '4': common_types_1.PRICE_STATE_NOW,
        '5': common_types_1.PRICE_STATE_NOW_FROM,
    },
    STD: { '1': common_types_1.PRICE_STATE_FROM, '4': common_types_1.PRICE_STATE_NOW, '5': common_types_1.PRICE_STATE_WAS },
    RRP: { '2': common_types_1.PRICE_STATE_RRP, '3': common_types_1.PRICE_STATE_RRP },
    EM: {},
};
const checkIfEmPriceIsLowest = (productPrices) => {
    let emIsLowestPrice = false;
    const allOtherPrices = Object.keys(productPrices)
        .filter(productPriceKey => productPriceKey !== 'EM')
        .map(productPriceKey => productPrices[productPriceKey]);
    allOtherPrices.forEach(otherPrice => (emIsLowestPrice = emIsLowestPrice && productPrices.EM.original < otherPrice.original));
    return emIsLowestPrice;
};
const generatePriceStateLabel = (priceType, priceState) => {
    var _a;
    if (!(0, general_util_1.isNullOrUndefined)(PRICE_STATUS_VISUAL[priceType]) &&
        !(0, general_util_1.isNullOrUndefined)((_a = PRICE_STATUS_VISUAL[priceType]) === null || _a === void 0 ? void 0 : _a[`${priceState}`])) {
        return PRICE_STATUS_VISUAL[priceType][`${priceState}`];
    }
    return undefined;
};
const generatePriceViewModelObject = (price, priceType, priceState) => ({
    intPrice: undefined,
    decPrice: undefined,
    original: price,
    priceState: generatePriceStateLabel(priceType, priceState),
});
const mapEdgePriceToPricesObject = (oldPrice) => {
    const productPrices = {
        SELL: generatePriceViewModelObject(oldPrice.sellPrice, common_types_1.PRICE_TYPE_SELL, oldPrice.priceState),
        STD: oldPrice.standardPrice
            ? generatePriceViewModelObject(oldPrice.standardPrice, common_types_1.PRICE_TYPE_STD, oldPrice.priceState)
            : undefined,
        RRP: oldPrice.rrpPrice
            ? generatePriceViewModelObject(oldPrice.rrpPrice, common_types_1.PRICE_TYPE_RRP, oldPrice.priceState)
            : undefined,
        EM: oldPrice.emPrice
            ? generatePriceViewModelObject(oldPrice.emPrice, common_types_1.PRICE_TYPE_EM, oldPrice.priceState)
            : undefined,
        LOWEST: oldPrice.lowestPrice
            ? generatePriceViewModelObject(oldPrice.lowestPrice, common_types_1.PRICE_TYPE_LOWEST, oldPrice.priceState)
            : undefined,
    };
    switch (oldPrice.priceState) {
        case 0:
        case 1:
            delete productPrices.STD;
            delete productPrices.RRP;
            break;
        case 2:
        case 3:
            delete productPrices.STD;
            if (!(0, general_util_1.isNullOrUndefined)(productPrices.RRP) && productPrices.RRP.original <= productPrices.SELL.original) {
                delete productPrices.RRP;
            }
            break;
        case 4:
        case 5:
            delete productPrices.RRP;
            break;
    }
    if (!checkIfEmPriceIsLowest(productPrices)) {
        delete productPrices.EM;
    }
    return productPrices;
};
exports.mapEdgePriceToPricesObject = mapEdgePriceToPricesObject;
const setColorPrices = (productPrice, colorId) => {
    const colorPrice = productPrice.colours.find(item => item.colourId === colorId);
    if ((0, general_util_1.isNullOrUndefined)(colorPrice)) {
        return {};
    }
    return {
        hasDifferentPrices: colorPrice.colourHasDifferentPrices,
        hasDiscount: colorPrice.priceState === 2 ||
            colorPrice.priceState === 3 ||
            colorPrice.priceState === 4 ||
            colorPrice.priceState === 5,
        markdown: colorPrice.markdown,
        prices: (0, exports.mapEdgePriceToPricesObject)(colorPrice),
        priceOverlay: {
            overlayCode: colorPrice.webThumbOverlayCode,
            overlayThumb: colorPrice.webThumbOverlayPicture,
        },
    };
};
exports.setColorPrices = setColorPrices;
var ProductPriceStates;
(function (ProductPriceStates) {
    ProductPriceStates["FROM"] = "FROM";
    ProductPriceStates["NOW_FROM"] = "NOW_FROM";
    ProductPriceStates["WAS"] = "WAS";
    ProductPriceStates["RRP"] = "RRP";
    ProductPriceStates["LOWEST"] = "LOWEST";
    ProductPriceStates["ORIGINAL"] = "ORIGINAL";
})(ProductPriceStates || (exports.ProductPriceStates = ProductPriceStates = {}));
const pricingStateTranslationConfig = {
    [ProductPriceStates.FROM]: 'product:product.price.from',
    [ProductPriceStates.NOW_FROM]: 'product:product.price.nowFrom',
    [ProductPriceStates.RRP]: 'product:product.price.rrp',
    [ProductPriceStates.WAS]: 'product:product.price.was',
    [ProductPriceStates.LOWEST]: 'product:product.price.lowest',
    [ProductPriceStates.ORIGINAL]: 'product:product.price.original',
};
const generatePriceLabel = (t, priceLabel) => !!priceLabel && pricingStateTranslationConfig[priceLabel] ? t(pricingStateTranslationConfig[priceLabel]) : ' ';
const generateCotopaxiPriceViewModel = (priceInformation, t, formatAsCurrency, enablePriceReference = false) => {
    var _a;
    if (!priceInformation.prices || !priceInformation.prices.SELL) {
        return {
            priceActual: {
                formattedPrice: '',
                priceLabel: '',
            },
            enablePriceReference,
        };
    }
    const priceActual = {
        formattedPrice: formatAsCurrency(priceInformation.prices.SELL.original),
        priceLabel: generatePriceLabel(t, priceInformation.prices.SELL.priceState),
    };
    let pricePrevious;
    let priceReference;
    if (priceInformation.hasDiscount && priceInformation.prices.STD) {
        pricePrevious = {
            formattedPrice: formatAsCurrency(priceInformation.prices.STD.original),
            priceLabel: generatePriceLabel(t, priceInformation.prices.STD.priceState),
        };
    }
    else if (priceInformation.prices.RRP) {
        pricePrevious = {
            formattedPrice: formatAsCurrency(priceInformation.prices.RRP.original),
            priceLabel: generatePriceLabel(t, priceInformation.prices.RRP.priceState),
        };
    }
    if ((0, exports.showLowestPriceLastMonth)(Boolean(enablePriceReference), (_a = priceInformation.prices.LOWEST) === null || _a === void 0 ? void 0 : _a.original) &&
        !!pricePrevious) {
        const { STD, RRP, SELL, LOWEST } = (0, exports.getOriginalPrices)(priceInformation.prices);
        const originalPrice = STD !== null && STD !== void 0 ? STD : RRP;
        if (!LOWEST || !originalPrice) {
            return {
                priceActual,
                pricePrevious,
                enablePriceReference,
            };
        }
        if (LOWEST > SELL && LOWEST < originalPrice) {
            priceReference = Object.assign(Object.assign({}, pricePrevious), { priceLabel: generatePriceLabel(t, ProductPriceStates.ORIGINAL) });
            pricePrevious = {
                formattedPrice: formatAsCurrency(LOWEST),
                priceLabel: undefined,
            };
        }
        else if (LOWEST <= SELL) {
            priceReference = {
                formattedPrice: formatAsCurrency(LOWEST),
                priceLabel: generatePriceLabel(t, ProductPriceStates.LOWEST),
            };
        }
    }
    return {
        priceActual,
        pricePrevious,
        priceReference,
        enablePriceReference,
    };
};
exports.generateCotopaxiPriceViewModel = generateCotopaxiPriceViewModel;
const prefixPriceWithCurrency = (value, currency) => Number(value) < 0 ? `- ${currency}${Math.abs(Number(value))}` : `${currency}${value}`;
exports.prefixPriceWithCurrency = prefixPriceWithCurrency;
const getRoundedPrice = (value) => Math.round((value + Number.EPSILON) * 100) / 100;
exports.getRoundedPrice = getRoundedPrice;
const showLowestPriceLastMonth = (enabled, lowestPrice) => enabled && !!lowestPrice;
exports.showLowestPriceLastMonth = showLowestPriceLastMonth;
const getOriginalPrices = (prices) => {
    var _a, _b, _c, _d, _e;
    return ({
        STD: (_a = prices.STD) === null || _a === void 0 ? void 0 : _a.original,
        RRP: (_b = prices.RRP) === null || _b === void 0 ? void 0 : _b.original,
        LOWEST: (_c = prices.LOWEST) === null || _c === void 0 ? void 0 : _c.original,
        SELL: (_d = prices.SELL) === null || _d === void 0 ? void 0 : _d.original,
        EM: (_e = prices.EM) === null || _e === void 0 ? void 0 : _e.original,
    });
};
exports.getOriginalPrices = getOriginalPrices;
const showPriceDiscount = (prices, enablePriceReference) => {
    var _a;
    if ((0, exports.showLowestPriceLastMonth)(Boolean(enablePriceReference), (_a = prices === null || prices === void 0 ? void 0 : prices.LOWEST) === null || _a === void 0 ? void 0 : _a.original)) {
        const { SELL, LOWEST } = (0, exports.getOriginalPrices)(prices);
        return LOWEST > SELL;
    }
    return true;
};
exports.showPriceDiscount = showPriceDiscount;
//# sourceMappingURL=price.util.js.map